export { default } from './PostAbbrev';
